import { set } from "@/utils/vuex";

export default {
  resetState(state) {
    Object.assign(state, state.getDefaultState());
  },
  setCoupons: set("coupons"),
  setCoupon: set("coupon"),
  setLoading: set("loading"),
};
